import ProductPropertyTypeConstants from "../constants/ProductPropertyTypes"

export const getApplicationPropertiesValidationConfig = (productPropertyFormats) => {
  if (!Array.isArray(productPropertyFormats) || productPropertyFormats?.length === 0) return null

  const config = productPropertyFormats.map(format => {
    const rules = {}

    if (format.required) {
      rules["isRequired"] = true
    }
    if (format.type === ProductPropertyTypeConstants.URL) {
      rules["isUrl"] = true
    }
    if (format.type === ProductPropertyTypeConstants.EMAIL) {
      rules["isEmail"] = true
    }
    if (format.validationRegEx) {
      rules["regex"] = {
        ex: format.validationRegEx,
        message: format.validationMessage,
      }
    }
    return {
      key: format.propertyKey,
      rules: rules
    }
  })
  return config
}

export default {
  getApplicationPropertiesValidationConfig
}